import React, { useRef, useState } from "react";
import TabsClassic from "src/components/TabsClassic";
import FilterTable from "src/components/FilterTable";
import ExternalActionsTable from "src/components/ExternalActionsTable";
import AgGridTable from "src/components/AgGridTable";
import { currencyFormatter } from "src/util/functions";

const COLUMN_DEF_PRODUCTOS = [
    {headerName: "ID Producto", field: "idProducto", minWidth: 130, resizable: true, sortable: false, filter: false},
    {headerName: "Nombre", field: "nombre", minWidth: 500, resizable: true, sortable: false, filter: false},
    {headerName: "Valor", field: "valor", minWidth: 200, valueFormatter: currencyFormatter, cellClass: 'number-cell', resizable: true, sortable: false, filter: false}
];

const COLUMN_DEF_CLIENTES = [
    {headerName: "ID Cliente", field: "idCliente", minWidth: 120, resizable: true, sortable: false, filter: false},
    {headerName: "Nombre", field: "nombreCliente", minWidth: 350, resizable: true, sortable: false, filter: false},
    {headerName: "Nombre Negocio", field: "nombreNegocio", minWidth: 350, resizable: true, sortable: false, filter: false}
];

const SeccionProductos = ({ productos, nombreLista }) => {
    const tableRefProductos = useRef(null);

    return (
        <div className="p-2 w-100">
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center w-50">
                    <FilterTable tableRef={tableRefProductos} identificador="searchFilterProductos" className="w-75 mx-2" />
                </div>

                <ExternalActionsTable
                    accionVisibilidadColumnas={tableRefProductos}
                    accionExcel={{
                        tableRef: tableRefProductos,
                        fileName: `Lista Precios - ${nombreLista} - Productos`,
                        sheetName: "Hoja de productos",
                    }}
                />
            </div>

            <div className="mx-2">
                <AgGridTable
                    referencia = {tableRefProductos}
                    columnDef = {COLUMN_DEF_PRODUCTOS}
                    defaultColDef = {{wrapHeaderText: true, autoHeaderHeight: true}}
                    dataList = {productos}
                    onGridReady={params => params.api.sizeColumnsToFit()}
                />
            </div>
        </div>
    );
}

const SeccionClientes = ({ clientes, nombreLista }) => {
    const tableRefClientes= useRef(null);

    return (
        <div className="p-2 w-100">
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center w-50">
                    <FilterTable tableRef={tableRefClientes} identificador="searchFilterProductos" className="w-75 mx-2" />
                </div>

                <ExternalActionsTable
                    accionVisibilidadColumnas={tableRefClientes}
                    accionExcel={{
                        tableRef: tableRefClientes,
                        fileName: `Lista Precios - ${nombreLista} - Clientes`,
                        sheetName: "Hoja de clientes",
                    }}
                />
            </div>

            <div className="mx-2">
                <AgGridTable
                    referencia = {tableRefClientes}
                    columnDef = {COLUMN_DEF_CLIENTES}
                    defaultColDef = {{wrapHeaderText: true, autoHeaderHeight: true}}
                    dataList = {clientes}
                    onGridReady={params => params.api.sizeColumnsToFit()}
                />
            </div>
        </div>
    );
}

const FormListaPreciosShow = ({properties}) => {
    const { data: { clientes, productos, nombreLista } } = properties;

    const [stateTab, setStateTab] = useState(1)

    return (
        <div className="p-2">
            <div className="d-flex align-items-center">
                <TabsClassic tabs={[
                    {
                        id: 1,
                        label: "Productos asociados",
                        content: <SeccionProductos productos={productos} nombreLista={nombreLista}/>
                    },
                    {
                        id: 2,
                        label: "Clientes asociados",
                        content: <SeccionClientes clientes={clientes} nombreLista={nombreLista}/>
                    }
                ]} initialState={1} stateTab={setStateTab}/>
            </div>
        </div>
    );
}

export default FormListaPreciosShow;